module.exports = __webpack_public_path__ + "static/media/coin.31a7be4b.svg";